import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type AssistantOutboxEventCountsResult = QueryAtomResult<
  typeof assistantOutboxEventCountsQueryAtom
>;

export const assistantOutboxEventCountsQueryAtom = createQueryAtomFactory(
  'auditLog.assistantOutboxEventCounts',
  () => ({
    assistantOutboxEventCounts: {
      chat: true,
      chatMessage: true,
    },
  }),
  {
    select: ({ assistantOutboxEventCounts }) => assistantOutboxEventCounts,
  },
);
